module.exports = __webpack_public_path__ + "img/help_active.b0a0f0e5.svg";